export default "__VITE_ASSET__d71ed106__"